import DropdownOptionRecord from "@infinode/records/DropdownOptionRecord";
import { List } from "immutable";

const DEMAND_TYPE_FIXED = "DEMAND_TYPE_FIXED";

const DEMAND_TYPES = {
  FIXED: DEMAND_TYPE_FIXED
};

const DEMAND_TYPE_LABELS = {
  [DEMAND_TYPE_FIXED]: "demand.type.fixed"
};

const DEMAND_TYPE_OPTIONS = List(
  Object.values(DEMAND_TYPES).map(t => DropdownOptionRecord({ id: t, label: DEMAND_TYPE_LABELS[t] }))
);

const DEMAND_ON_LABEL = "demand.on";
const DEMAND_OFF_LABEL = "demand.off";

const DEMAND_INTERVALS = [10, 15, 20, 30, 60];

const DEMAND_INTERVAL_OPTIONS = List(DEMAND_INTERVALS.map(i => DropdownOptionRecord({ id: i, label: `${i}min` })));

const DEMAND_VALUE_PROP_NAME = "apparentPower";

const DEMAND_VALUE_LABELS = {
  [DEMAND_VALUE_PROP_NAME]: "Demand"
};

export {
  DEMAND_TYPES,
  DEMAND_TYPE_LABELS,
  DEMAND_INTERVALS,
  DEMAND_ON_LABEL,
  DEMAND_OFF_LABEL,
  DEMAND_TYPE_OPTIONS,
  DEMAND_INTERVAL_OPTIONS,
  DEMAND_VALUE_PROP_NAME,
  DEMAND_VALUE_LABELS
};
